<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ProductBlock from '../parts/ProductBlock.vue';
import { formatDateTime } from '../helpers';

const props = defineProps({
  source: { type: Object, required: true },
  platform: { type: String, default: '' },
});

const { t, locale } = useI18n();
const question = computed(() => props.source.question || {});
const product = computed(() => props.source.product || {});
</script>

<template>
  <div class="flex flex-col gap-3">
    <ProductBlock v-if="product.name" :product="product" :platform="platform" />
    <div
      v-if="question.text"
      class="flex gap-2.5 p-3 rounded-lg bg-n-blue-2 border border-n-blue-4"
    >
      <span
        class="i-lucide-circle-help size-4 mt-0.5 flex-shrink-0 text-n-blue-11"
      />
      <div class="flex flex-col gap-1 min-w-0">
        <span
          class="text-[11px] font-semibold uppercase tracking-wide text-n-blue-11"
        >
          {{ t('MULTICHAT.SOURCE.QUESTION.TITLE') }}
          <span
            v-if="question.created_at"
            class="font-normal normal-case tracking-normal text-n-slate-10"
          >
            · {{ formatDateTime(question.created_at, locale) }}
          </span>
        </span>
        <p
          class="m-0 text-[13px] leading-5 text-n-slate-12 whitespace-pre-line"
        >
          {{ question.text }}
        </p>
      </div>
    </div>
  </div>
</template>
